// @ts-ignore
import config from "./config.json";
export default config;
